import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';

/** Clickable card outlined thin in the divider color, thick in the brand color while selected. */
export const SelectableCard = styled(Card, {
  shouldForwardProp: prop => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  cursor: 'pointer',
  border: selected
    ? `2px solid ${theme.palette.primary.main}`
    : `1px solid ${theme.palette.divider}`,
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));
